'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

//
//
//
//
//
//
var script = {
  name: 'Timeline',
  props: {
    timelineTheme: {
      type: String,
      "default": '#dbdde0'
    },
    timelineBg: {
      type: String,
      "default": '#fff'
    }
  },
  mounted: function mounted() {
    var timeline = this.$refs.timeline;
    timeline.style.setProperty('--timelineTheme', this.timelineTheme);
    timeline.style.setProperty('--timelineBg', this.timelineBg);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ul', {
    ref: "timeline",
    staticClass: "timeline"
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var script$1 = {
  name: 'TimelineItemBase',
  props: {
    bgColor: {
      type: String,
      "default": ''
    },
    lineColor: {
      type: String,
      "default": ''
    },
    hollow: {
      type: Boolean,
      "default": false
    },
    iconSize: {
      type: String,
      "default": ''
    },
    fontColor: {
      type: String,
      "default": '#37414a'
    }
  },
  data: function data() {
    return {
      slotOthers: false,
      iconSizeData: {
        'small': {
          'top': '.28em',
          'left': '-34px',
          'width': '10px',
          'height': '10px'
        },
        'medium': {
          'top': '0em',
          'left': '-39.5px',
          'height': '20px',
          'width': '20px'
        },
        'large': {
          'top': '-0.5em',
          'left': '-44px',
          'height': '30px',
          'width': '30px'
        }
      }
    };
  },
  computed: {
    circleStyle: function circleStyle() {
      if (!this.bgColor && !this.lineColor && !this.hollow && !this.iconSize) return;
      var style = {};

      if (this.bgColor) {
        style = {
          'border-color': this.bgColor,
          'background-color': this.bgColor
        };
      }

      if (this.lineColor) {
        style = Object.assign({}, style, {
          'border-color': this.lineColor
        });
      }

      if (this.iconSizeData[this.iconSize]) {
        style = Object.assign({}, style, this.iconSizeData[this.iconSize]);
      }

      return style;
    },
    itemStyle: function itemStyle() {
      return {
        'color': this.fontColor
      };
    },
    slotClass: function slotClass() {
      var className = '';

      if (this.slotOthers) {
        className = 'timeline-others';
      } else if (this.hollow) {
        className = 'hollow';
      }

      return className;
    }
  },
  mounted: function mounted() {
    this.slotOthers = !!this.$refs.others.innerHTML;
  }
};

/* script */
var __vue_script__$1 = script$1;
/* template */

/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent_1({}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

//
var script$2 = {
  "extends": __vue_component__$1
};

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('li', {
    staticClass: "timeline-item",
    style: _vm.itemStyle
  }, [_c('div', {
    ref: "others",
    staticClass: "timeline-circle",
    "class": _vm.slotClass,
    style: _vm.circleStyle
  }, [_vm._t("others")], 2), _vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

//
var script$3 = {
  "extends": __vue_component__$1
};

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('li', {
    staticClass: "timeline-title",
    style: _vm.itemStyle
  }, [_c('div', {
    ref: "others",
    staticClass: "timeline-circle timeline-title-circle",
    "class": _vm.slotClass,
    style: _vm.circleStyle
  }, [_vm._t("others")], 2), _vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component(__vue_component__.name, __vue_component__);
  window.Vue.component(__vue_component__$2.name, __vue_component__$2);
  window.Vue.component(__vue_component__$3.name, __vue_component__$3);
}

exports.Timeline = __vue_component__;
exports.TimelineItem = __vue_component__$2;
exports.TimelineTitle = __vue_component__$3;
